import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { Autocomplete, Checkbox, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from "@mui/material";
import { IDataPesquisarSafra } from "../../types/api/cafe/pesquisar-safra-cafe";
import { filtrarTodosEmArrayDeStrings } from "./helpers";

export default function SelectSafraCafe({
    value,
    onChange,
    type = "single"
}: SelectSimpleApiQueryProps) {

    //queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-safra-cafe"],
        queryFn: () => axiosClient.get("pesquisar-safra-cafe", {
            params: {
                limit: 50
            }
        })
    });

    const listData: IDataPesquisarSafra[] = data?.data?.safra || []
    //

    if (type === "single") return (
        <Autocomplete
            disablePortal
            disabled={isLoading}
            id="combo-box-demo"
            value={value as SingleValue}
            options={listData.map((i, index) => i.safra)}
            onChange={(_: any, newValue: SingleValue) => {
                onChange(newValue);
            }}
            renderInput={(params) => <TextField {...params} label={isLoading ? "Carregando" : "Safra"} fullWidth />}
        />
    )

    //type == multiple
    const valorFormatado = value ?? []

    const handleChangeMultipleValue = (event: SelectChangeEvent<string[]>) => {
        const valorFinal = filtrarTodosEmArrayDeStrings(event.target.value as string[])
        onChange(valorFinal as string[])
    }
    //

    return (
        <FormControl fullWidth>
            <InputLabel id="safra-cafe">{isLoading ? "Carregando" : "Safras"}</InputLabel>
            <Select
                labelId="safra-cafe"
                id="demo-multiple-name"
                multiple
                disabled={isLoading}
                value={valorFormatado as string[]}
                onChange={handleChangeMultipleValue}
                input={<OutlinedInput label="Safras" />}
                renderValue={(selected) => selected.join(", ")}
            >
                <MenuItem value="Todos(as)">
                    <Checkbox checked={valorFormatado.indexOf("Todos(as)") > -1} />
                    Todos(as)
                </MenuItem>

                {[...listData].map((item) => {
                    const valorOption = item.safra
                    return (
                        <MenuItem
                            key={valorOption}
                            value={valorOption}
                        >
                            <Checkbox checked={valorFormatado.indexOf(valorOption) > -1} />
                            {valorOption}
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

interface SelectSimpleApiQueryProps {
    type?: 'single' | 'multiple';
    value: SelectValue;
    onChange: (arg: SelectValue) => void;
}

type SelectValue = SingleValue | MultipleValue;

type SingleValue = string | null;
type MultipleValue = string[];